module.exports = __webpack_public_path__ + "static/media/information-icon.f80dbba8.svg";